import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'signup-open_brandpage_main_cta-click';
/**
 * Event fired when user clicks the main sign up in a logged out brand page
 */ export function trackSignupOpenBrandpageMainCtaClick() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false
    });
}
